import { defineMessages } from "react-intl";

export default defineMessages({
    emptyProject: {
        id: "components.tree.treeWrapper.emptyProject",
        defaultMessage: "This project is empty", // Dieses Projekt ist leer
    },
});
